import {
  productPaymentConfigService,
  type UpdateProductPaymentGatewayPayload,
} from '@/services';
import { useMutation } from '@tanstack/react-query';
import { useInvalidatePaymentSettings } from './use-invalidate-payment-settings.hook';

/** Salva a aba "Cobrança e formas". Lança com a mensagem do servidor (ex.: 409 de versão). */
export function useUpdatePaymentGateway(productCode: string) {
  const invalidate = useInvalidatePaymentSettings();

  return useMutation({
    mutationFn: async (payload: UpdateProductPaymentGatewayPayload) => {
      const response = await productPaymentConfigService.updatePaymentGateway(
        productCode,
        payload
      );
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Não foi possível salvar a cobrança do produto.'
        );
      }
      return response.data;
    },
    onSuccess: invalidate,
  });
}
